import { flattenArray, updateJsonByElement } from "app/paywallBuilderV2/contexts/JsonProvider/utils"
import { TPaywallTemplate } from "app/schema/paywallTemplate/paywallTemplate"
import _ from "lodash"

export const defaultEscape = (str: string) => {
  if (!str) return str

  return str.replace(/\"/g, '\\"').replace(/\n/g, "\\n").replace(/\t/g, "\\t");
}

export const escapeJS = (str: string) => {
  if (!str) return str

  return defaultEscape(str).replace(/\`/g, '\\"');
}

export const escapeAllHTMLComponents = (parsedJson: TPaywallTemplate) => {
  const { backgroundContent, mainContent, cardContent } = parsedJson

  let parsedJsonCopy = _.cloneDeep(parsedJson)

  /**
   * The following simply escapes double quotes and new lines in the html element
   * so the json parsing works correctly when the base template uses the json value.
   */
  const flatContents = flattenArray([
    ...(backgroundContent || []),
    ...(mainContent || []),
    ...(cardContent || []),
  ])
  const htmlElements = flatContents.filter((el) => el.name === "html")
  const escapedHtmlElements = htmlElements.map((el) => {
    const { settings, ...rest } = el

    const escapedValue = defaultEscape(settings.value)

    return {
      ...rest,
      settings: {
        ...settings,
        value: escapedValue,
      },
    }
  })

  escapedHtmlElements.forEach((el) => {
    parsedJsonCopy = updateJsonByElement(parsedJsonCopy, el).parsedJson
  })

  return parsedJsonCopy
}

/**
 * TODO: Possibly break up this function into smaller pieces.
 *
 * This function is used to escape special characters in templateJson. The important
 * parts include all html elements, customJS, and customCSS. These parts may contain
 * special characters which we need to escape when we save the stringified json to the
 * individually created builderTemplate html files.
 */
export const escapeSpecialCharsInTemplateJson = ({
  parsedJson,
}: {
  parsedJson: TPaywallTemplate
}) => {
  parsedJson = escapeAllHTMLComponents(parsedJson)

  const { pageSettings } = parsedJson!
  const { customJS, customCSS } = pageSettings!

  let newCustomJS = customJS
  if (customJS && !_.isEmpty(pageSettings) && !_.isEmpty(parsedJson)) {
    newCustomJS = escapeJS(customJS)
    parsedJson!.pageSettings!.customJS = newCustomJS
  }

  let newCustomCSS = customCSS
  if (customCSS && !_.isEmpty(pageSettings) && !_.isEmpty(parsedJson)) {
    newCustomCSS = defaultEscape(customCSS)
    parsedJson!.pageSettings!.customCSS = newCustomCSS
  }

  return parsedJson
}
